import React from 'react';
import {FieldViewSmallProps} from "../../../../render/view-small";



export default function FieldSystemLogStatus_ViewSmall(props:FieldViewSmallProps) {

    const value = props.field.getViewValue(props.model)

    let valueLabel
    let valueClass

    switch (value) {
        case 1:
            valueLabel = "Success"
            valueClass = 'ui5-txt-green'
            break
        case 2:
            valueLabel = "Skip";
            valueClass = 'ui5-txt-orange'
            break
        case 3:
            valueLabel = "Error";
            valueClass = 'ui5-txt-red'
            break
    }


    return <div className={Classes("ui5-txt-less-important-small",valueClass)}>{valueLabel}</div>
}
